module.exports = __webpack_public_path__ + "img/partner3.1ddf8ec3.png";